import { render } from "./StockApiBoard.vue?vue&type=template&id=0b9ac55c"
import script from "./StockApiBoard.vue?vue&type=script&lang=js"
export * from "./StockApiBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__